<template>
  <div>
    <setUserTable />
    <div class="d_f" @click="input_blur">
      <div class="con">
        <p class="title">公司员工</p>
        <div class="search">
          <!--遮罩层 用于关闭搜索结果窗口-->
          <div v-show="showSearchResult" @click="showSearchResult = false" class="cover"></div>
          <label>
            <i class="el-icon-search search_s" v-show="search_isshow1"></i>
            <input
              type="text"
              v-model="filterText"
              @focus="openSearchResult"
              @click.stop="input_focus(1)"
            />
            <i class="el-icon-search" v-show="!search_isshow1"></i>
            <span v-show="!search_isshow1">搜索成员姓名、ID</span>
          </label>
          <div v-show="showSearchResult" class="search-result">
            <!--空显示-->
            <div v-if="searchUserList.length === 0" class="no-result">没有搜索到结果</div>
            <div class="search-container" v-if="searchUserList.length !== 0">
              <div class="search-title">
                <span>成员</span>
                <el-button
                  type="text"
                  v-if="searchUserList.length > 3"
                  @click="fewUser = !fewUser"
                  style="color: #909399; font-weight: normal"
                >
                  {{ fewUser ? '显示更多' : '收起' }}
                </el-button>
                <el-button v-else type="text" style="color: #909399; font-weight: normal">
                  已加载全部
                </el-button>
              </div>
              <div
                v-for="user in searchResultUser"
                :key="user.userid"
                class="search-label"
                @click="getWeComDepartmentUserList(user.userid)"
              >
                <div class="search-label-left">
                  <span :title="user.name" style="width: 120px; height: 18px">{{ user.name }}</span>
                  <span :title="user.department" style="width: 155px; font-size: 14px">
                    {{ user.department }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="title">
          <i class="el-icon-s-order icon_color"></i>
          {{ firm_name }}
        </p>
        <div class="tree" v-loading="treeLoading">
          <el-tree
            ref="tree"
            :load="loadNode"
            :props="defaultProps"
            :expand-on-click-node="false"
            lazy
          >
            <div
              class="custom-tree-node"
              slot-scope="{ node, data }"
              style="flex: 1; height: 100%; line-height: 26px"
              @click="getWeComDepartmentUserList(data.userid)"
            >
              <span v-html="data.name"></span>
            </div>
          </el-tree>
        </div>
      </div>
      <div class="con">
        <p class="title">联系人</p>
        <div class="search">
          <label>
            <i class="el-icon-search search_s" v-show="search_isshow2"></i>
            <input type="text" v-model="input2" @click.stop="input_focus(2)" />
            <i class="el-icon-search" v-show="!search_isshow2"></i>
            <span v-show="!search_isshow2">请输入关键词搜索</span>
          </label>
          <div v-show="isshow2" class="search_content">
            <div
              :class="content_box[1] ? 'content_boxs' : 'content_box'"
              v-if="interiorList.length > 0"
            >
              <div class="content_title">
                <span class="span1">内部联系人</span>
                <span class="span2" @click.stop="conetnt_more(1)">
                  {{ content_box[1] ? '收起' : '显示更多' }}
                </span>
              </div>
              <div
                class="content_list"
                v-for="(item, index) in interiorList"
                :key="index"
                @click.stop="content2_list(item.username, item.userid, 1)"
              >
                <h3>
                  {{ item.username }}
                  <span :class="item.to_type == 2 ? 'external_color' : ''" v-if="item.to_type == 2">
                    @{{ item.to_corp_name }}
                  </span>
                  <span v-if="item.to_type == 2" class="span_icon">外部</span>
                </h3>
                <p>{{ item.department_level }}</p>
              </div>
            </div>
            <div
              :class="content_box[2] ? 'content_boxs' : 'content_box'"
              v-if="externalList.length > 0"
            >
              <div class="content_title">
                <span class="span1">外部联系人</span>
                <span class="span2" @click.stop="conetnt_more(2)">
                  {{ content_box[2] ? '收起' : '显示更多' }}
                </span>
              </div>
              <div
                class="content_list"
                v-for="(item, index) in externalList"
                :key="index"
                @click.stop="content2_list(item.username, item.userid, 2)"
              >
                <h3>
                  {{ item.username }}
                  <span :class="item.to_type == 2 ? 'external_color' : ''" v-if="item.to_type == 2">
                    @{{ item.to_corp_name }}
                  </span>
                  <span v-if="item.to_type == 2" class="span_icon">外部</span>
                </h3>
                <p>{{ item.department_level }}</p>
              </div>
            </div>
            <div
              :class="content_box[3] ? 'content_boxs' : 'content_box'"
              v-if="groupList.length > 0"
            >
              <div class="content_title">
                <span class="span1">客户群聊</span>
                <span class="span2" @click.stop="conetnt_more(3)">
                  {{ content_box[3] ? '收起' : '显示更多' }}
                </span>
              </div>
              <div
                class="content_list"
                v-for="(item, index) in groupList"
                :key="index"
                @click.stop="content2_list(item.username, item.userid, 3)"
              >
                <h3>
                  {{ item.username }}
                  <span :class="item.to_type == 2 ? 'external_color' : ''" v-if="item.to_type == 2">
                    @{{ item.to_corp_name }}
                  </span>
                  <span v-if="item.to_type == 2" class="span_icon">外部</span>
                </h3>
                <p>{{ item.department_level }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="contacts_title" v-if="contacts_title_type">
          <div
            :class="
              person_list_index === 1 ? 'contacts_title_bc contacts_title_s' : 'contacts_title_s'
            "
            @click.stop="person_list(1)"
          >
            内部联系人
          </div>
          <div
            :class="
              person_list_index === 2 ? 'contacts_title_bc contacts_title_s' : 'contacts_title_s'
            "
            @click.stop="person_list(2)"
          >
            外部联系人
          </div>
          <div
            :class="
              person_list_index === 3 ? 'contacts_title_bc contacts_title_s' : 'contacts_title_s'
            "
            @click.stop="person_list(3)"
          >
            客户群聊
          </div>
        </div>
        <div class="relation_list" v-if="person_list_index === 1 || person_list_index === 2">
          <div
            class="relation_list_s"
            :style="relation_list_index === index ? 'background: #F5F7FA' : ''"
            v-for="(item, index) in relation_list"
            :key="index"
            @click.stop="relation_list_click(item.from, item.to, item.roomid, index)"
          >
            <h3>
              {{ item.to_name || item.to_nickname || item.from_name }}
              <span :class="item.to_type === 2 ? 'external_color' : ''" v-if="item.to_type === 2">
                @{{ item.to_corp_name }}
              </span>
              <span v-if="item.to_type === 2" class="span_icon">外部</span>
            </h3>
            <p v-if="item.msgtype === 'text'">
              {{ item.content.content }}
            </p>
            <p v-else>{{ state_list[item.msgtype] }}</p>
          </div>
          <div class="relation_list_pages" v-if="relation_list.length > 0">
            <el-pagination
              small
              layout="prev, pager, next"
              :current-page="relation_index"
              @current-change="handleCurrentChange"
              :page-size="relation_size"
              :total="relation_total"
            ></el-pagination>
          </div>
        </div>
        <div class="relation_list" v-if="person_list_index === 3">
          <div
            class="relation_list_s"
            :style="relation_list_index_group === index ? 'background: #F5F7FA' : ''"
            v-for="(item, index) in relation_list_group"
            :key="index"
            @click.stop="relation_list_click(item.from, item.to, item.roomid, index)"
          >
            <h3 class="relation_list_h3">
              {{ item.room_name }}
              <span :class="item.to_type == 2 ? 'external_color' : ''" v-if="item.to_type == 2">
                @{{ item.to_corp_name }}
              </span>
              <span v-if="item.to_type == 2" class="span_icon">外部</span>
            </h3>
            <p v-if="item.msgtype === 'text'">
              {{ item.content.content }}
            </p>
            <p v-else>{{ state_list[item.msgtype] }}</p>
          </div>
          <div class="relation_list_pages" v-if="relation_list_group.length > 0">
            <el-pagination
              small
              layout="prev, pager, next"
              :current-page="relation_index_group"
              @current-change="handleCurrentChange_group"
              :page-size="relation_size_group"
              :total="relation_total_group"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="con" id="con_s">
        <p class="title">会话记录</p>
        <div class="dialogue_list">
          <div class="dialogue_list_s" v-for="(item, index) in dialogue_list" :key="index">
            <h3 class="dialogue_list_h3">
              {{ item.from_name || item.from_nickname || item.to_name }}
              <span :class="item.from_type == 2 ? 'external_color' : ''" v-if="item.from_type == 2">
                @{{ item.from_nickname }}
              </span>
              <span v-if="item.from_type == 2" class="span_icon">外部</span>
              <i>{{ dateFormat(new Date(item.msgtime), 'YYYY-MM-dd HH:mm:SS') }}</i>
            </h3>
            <!-- 图片消息 -->
            <div
              class="msgtype_image"
              v-if="item.msgtype === 'image' || item.msgtype === 'emotion'"
            >
              <msgtypeImage :items="item" />
            </div>
            <!-- 文本消息 -->
            <div class="msgtype_text" v-if="item.msgtype === 'text'">
              <msgtypeText :items="item" />
            </div>
            <!-- 同意消息 -->
            <div class="msgtype_agree">
              <p v-if="item.msgtype === 'agree'">{{ state_list[item.msg_type] }}</p>
              <p v-if="item.msgtype === 'disagree'">{{ state_list[item.msg_type] }}</p>
            </div>
            <!-- 语音消息 -->
            <div class="msgtype_voice" v-if="item.msgtype === 'voice'">
              <msgtypeVoice :items="item" />
            </div>
            <!-- 视频消息 -->
            <div class="msgtype_video" v-if="item.msgtype === 'video'">
              <msgtypeVideo :items="item" />
            </div>
            <!-- 名片消息 -->
            <div
              class="msgtype_card"
              v-if="
                item.msgtype === 'card' ||
                item.msgtype === 'calendar' ||
                item.msgtype === 'todo' ||
                item.msgtype === 'vote' ||
                item.msgtype === 'collect' ||
                item.msgtype === 'docmsg' ||
                item.msgtype === 'file' ||
                item.msgtype === 'meeting'
              "
            >
              <msgtypeCard :items="item" />
            </div>
            <!-- 位置消息 -->
            <div class="msgtype_location" v-if="item.msgtype === 'location'">
              <msgtypeLocation :items="item" :index="index" />
            </div>
            <!-- 链接消息 -->
            <div class="msgtype_link" v-if="item.msgtype === 'link'">
              <msgtypeLink :items="item" />
            </div>
            <!-- 小程序消息 -->
            <div class="msgtype_weapp" v-if="item.msgtype === 'weapp'">
              <msgtypeWeapp :items="item" />
            </div>
            <!-- 聊天记录消息 -->
            <div class="msgtype_chatrecord" v-if="item.msgtype === 'chatrecord'">
              <msgtypeChatrecord :items="item" />
            </div>
            <!-- 图文消息 -->
            <div class="msgtype_news" v-if="item.msgtype === 'news'">
              <msgtypeNews :items="item" />
            </div>
            <!-- 混合消息 -->
            <div class="msgtype_mixed" v-if="item.msgtype === 'mixed'">
              <msgtypeMixed :items="item" />
            </div>
            <!-- 音频共享文档消息 -->
            <div
              class="msgtype_voip_doc_share"
              v-if="
                item.msgtype === 'voip_doc_share' ||
                item.msgtype === 'markdown' ||
                item.msgtype === 'external_redpacket' ||
                item.msgtype === 'meeting_voice_call' ||
                item.msgtype === 'redpacket'
              "
            >
              <p>{{ state_list[item.msg_type] }}</p>
            </div>
            <!-- 切换企业日志消息 -->
            <div class="msgtype_action_switch" v-if="item.msgtype === 'action_switch'">
              <p>{{ item.content }}</p>
            </div>
          </div>
          <div class="dialogue_list_pages" v-if="dialogue_list.length > 0">
            <el-pagination
              small
              layout="prev, pager, next"
              :current-page="dialogue_index"
              @current-change="handleCurrentChanges"
              :page-size="dialogue_size"
              :total="dialogue_total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateFormat } from '@/utils/time';
import msgtypeVideo from './components/sessionInformation/msgtypeVideo';
import msgtypeImage from './components/sessionInformation/msgtypeImage';
import msgtypeCard from './components/sessionInformation/msgtypeCard';
import msgtypeText from './components/sessionInformation/msgtypeText';
import msgtypeLink from './components/sessionInformation/msgtypeLink';
import msgtypeVoice from './components/sessionInformation/msgtypeVoice';
import msgtypeMixed from './components/sessionInformation/msgtypeMixed';
import msgtypeLocation from './components/sessionInformation/msgtypeLocation';
import msgtypeChatrecord from './components/sessionInformation/msgtypeChatrecord';
import msgtypeNews from './components/sessionInformation/msgtypeNews';
import msgtypeWeapp from './components/sessionInformation/msgtypeWeapp';
import setUserTable from './components/setUserTable';
import {
  EyaoSaasGetChatListByUserID,
  EyaoSaasSearchChatContact,
  EyaoSaasGetChatDetailList,
  EyaoSaasGetRoomListByUserID,
} from '@/api/enterpriseWeChatManagement';
import {
  GetWeComDepartmentById,
  GetWeComUserByName,
  // GetWeComUserByName,
  // GetWeComUserDetail,
  // GetWeComAllUsers,
} from '@/api/addressList';
export default {
  name: '',
  components: {
    msgtypeVideo,
    msgtypeImage,
    msgtypeCard,
    msgtypeText,
    msgtypeLink,
    msgtypeVoice,
    msgtypeMixed,
    msgtypeLocation,
    msgtypeChatrecord,
    msgtypeNews,
    msgtypeWeapp,
    setUserTable,
  },
  props: {},
  data() {
    return {
      dateFormat,
      defaultExpanded: [], // 默认展开树节点的id
      showTree: true,
      treeLoading: true,
      defaultProps: {
        children: 'children',
        label: 'department_name',
        isLeaf: 'leaf',
      },
      firm_name: '',
      input1: '',
      isshow1: false,
      search_isshow1: false,
      input2: '',
      isshow2: false,
      search_isshow2: false,
      searchUserList: [],
      fewUser: true,
      showSearchResult: false,
      filterText: '',
      content_box: [false, false, false, false],
      contacts_list: [],
      interiorList: [],
      externalList: [],
      groupList: [],
      relation_list: [], // 联系人列表
      relation_size: 10, // 联系人每页显示条数
      relation_index: 1, // 联系人当前页
      relation_total: 1, // 联系人总条数
      relation_list_index: 1, // 联系人选中项
      dialogue_list: [], // 会话记录列表
      dialogue_size: 10, // 会话记录每页显示条数
      dialogue_index: 1, // 会话记录当前页
      dialogue_total: 1, // 会话记录总条数
      relation_list_group: [], // 群聊联系人列表
      relation_size_group: 10, // 群聊联系人每页显示条数
      relation_index_group: 1, // 群聊联系人当前页
      relation_total_group: 1, // 群聊联系人总条数
      relation_list_index_group: null,
      from: '',
      to: '',
      roomid: '',
      person_list_index: 1,
      state_list: {
        image: '[图片消息]',
        text: '[文本消息]',
        revoke: '[撤回消息]',
        agree: '[同意消息]',
        disagree: '[不同意消息]',
        voice: '[语音消息]',
        video: '[视频消息]',
        card: '[名片消息]',
        location: '[位置消息]',
        emotion: '[表情消息]',
        file: '[文件消息]',
        link: '[链接消息]',
        weapp: '[小程序消息]',
        chatrecord: '[聊天记录消息]',
        todo: '[待办消息]',
        vote: '[投票消息]',
        collect: '[填表消息]',
        redpacket: '[红包消息]',
        meeting: '[会议邀请消息]',
        docmsg: '[在线文档消息]',
        markdown: '[MarkDown格式消息]',
        newsnews: '[图文消息]',
        calendar: '[日程消息]',
        mixed: '[混合消息]',
        meeting_voice_call: '[音频存档消息]',
        voip_doc_share: '[音频共享文档消息]',
        external_redpacket: '[互通红包消息]',
        action_switch: '[切换企业日志消息]',
      },
      contacts_title_type: false, // 联系人选项卡
      to_id: '',
      userid: '',
    };
  },
  computed: {
    searchResultUser() {
      // 用于展开和收起，展示部分或全部搜索结果
      if (this.fewUser && this.searchUserList.length > 3) {
        return this.searchUserList.slice(0, 3);
      }
      return this.searchUserList;
    },
  },
  watch: {
    input1(val) {
      const vals = val.replace(/\s+/g, '');
      if (vals.length === 0) {
        this.isshow1 = false;
        this.userid = '';
      } else {
        this.input1_list(vals);
      }
    },
    input2(val) {
      const vals = val.replace(/\s+/g, '');
      if (vals.length === 0) {
        this.isshow2 = false;
        this.to_id = '';
      } else {
        this.input2_list(vals);
      }
    },
    filterText(val) {
      // this.search_isshow1 = !!val;
      if (val) {
        this.searchName();
      } else {
        this.showSearchResult = false;
      }
    },
  },
  created() {
    this.init();
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '企业微信管理管理', menu_path: '', menu_params: {} },
      { menu_name: '会话留存', menu_path: '', menu_params: {} },
      { menu_name: '会话查看', menu_params: { componentName: 'chattingRecords' } },
    ];
    this.g_breadcrumb(breadcrumb);
  },

  methods: {
    /* 页面初始化 */
    init() {},
    // 根据员工id获取会话列表
    async EyaoSaasGetChatListByUserID() {
      this.contacts_title_type = true;
      const req = Object.assign({
        userid: this.userid,
        page_index: this.relation_index,
        page_size: this.relation_size,
        to_type: this.person_list_index.toString(),
        to_id: this.to_id,
      });
      EyaoSaasGetChatListByUserID(req)
        .then((res) => {
          if (res) {
            const list = [];
            for (let i = 0; i < res.list.length; i++) {
              // if (res.list[i].to_name) {
              if (res.list[i].msgtype !== 'action_switch') {
                try {
                  res.list[i].content = JSON.parse(res.list[i].content);
                } catch (err) {
                  this.$message.error(err);
                  // res.list[i].content = res.list[i].content;
                }
              }
              // else {
              //   res.list[i].content = res.list[i].content;
              // }
              list.push(res.list[i]);
              // }
            }
            this.relation_list = list;
            this.relation_total = res.total;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 联系人选择页
    handleCurrentChange(val) {
      this.relation_index = val;
      this.EyaoSaasGetChatListByUserID();
    },
    // 根据部门id 获取企业微信用户列表
    getWeComDepartmentUserList(userid) {
      if (userid) {
        this.userid = userid;
        this.EyaoSaasGetChatListByUserID();
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 搜索框获取焦点事件
    input_focus(index) {
      this.input_blur();
      if (index === 1) {
        this.search_isshow1 = true;
        if (this.input1) {
          this.input1_list(this.input1);
        }
      } else {
        this.search_isshow2 = true;
        if (this.input2) {
          this.input2_list(this.input2);
        }
      }
    },
    // 搜索失去焦点事件
    input_blur() {
      this.isshow1 = false;
      this.isshow2 = false;
      this.content_box = [false, false, false, false];
      this.search_isshow1 = !!this.filterText;
      this.search_isshow2 = !!this.input2;
    },
    // 联系人输入事件
    input2_list(val) {
      this.isshow2 = true;
      if (!this.userid) {
        this.$message.error('请选择员工');
        return false;
      }
      const tempFun = this.deb(() => {
        EyaoSaasSearchChatContact({
          keyword: val,
          from_userid: this.userid,
        })
          .then((res) => {
            const { list } = res;
            const interiorList = [];
            const externalList = [];
            const groupList = [];
            for (let i = 0; i < list.length; i++) {
              if (list[i].to_type === '1') {
                interiorList.push(list[i]);
              }
              if (list[i].to_type === '2') {
                externalList.push(list[i]);
              }
              if (list[i].to_type === '3') {
                groupList.push(list[i]);
              }
            }
            this.interiorList = interiorList;
            this.externalList = externalList;
            this.groupList = groupList;
          })
          .catch((err) => {
            this.$message.error(err);
          });
      }, 300);
      tempFun();
    },
    // 员工搜索点击事件
    content1_list(name, userid) {
      this.input1 = name;
      setTimeout(() => {
        this.isshow1 = false;
        this.userid = userid;
        this.relation_list_index = 1;
        this.EyaoSaasGetChatListByUserID();
      }, 100);
    },
    // 联系人搜索列表点击事件
    content2_list(name, userid, index) {
      this.input2 = name;
      this.relation_list_index = index;
      this.person_list_index = index;
      this.relation_list.length = 0;
      this.relation_list_group.length = 0;
      setTimeout(() => {
        this.isshow2 = false;
        this.to_id = userid;
        this.EyaoSaasGetChatListByUserID();
      }, 100);
    },
    // 显示更多事件
    conetnt_more(index) {
      this.$set(this.content_box, index, !this.content_box[index]);
    },
    // 联系人列表点击事件
    // 阿斯顿发
    relation_list_click(from, to, roomid, index) {
      this.dialogue_index = 1;
      this.relation_list_index = index;
      this.relation_list_index_group = index;
      this.from = from;
      this.to = to;
      this.roomid = roomid;
      this.EyaoSaasGetChatDetailList();
    },
    // 获取会话聊天记录
    async EyaoSaasGetChatDetailList() {
      const req = {
        from: this.from,
        to: this.to,
        roomid: this.roomid,
        page_index: this.dialogue_index,
        page_size: this.dialogue_size,
      };

      EyaoSaasGetChatDetailList(req)
        .then((res) => {
          if (res) {
            const lists = [];
            for (let i = 0; i < res.list.length; i++) {
              if (res.list[i].msgtype !== 'action_switch') {
                try {
                  res.list[i].content = JSON.parse(res.list[i].content);
                } catch (err) {
                  res.list[i].content = res.list[i].content;
                }
              } else {
                res.list[i].content = res.list[i].content;
              }
              lists.push(res.list[i]);
            }
            console.log(lists);
            this.dialogue_list = lists;
            this.dialogue_total = res.total;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 会话聊天记录选择页
    handleCurrentChanges(val) {
      this.dialogue_index = val;
      this.EyaoSaasGetChatDetailList();
    },
    // 群聊联系人选择页
    handleCurrentChange_group(val) {
      this.relation_index = val;
      this.groupChat();
    },
    // 客户群聊
    async groupChat() {
      const req = Object.assign({
        from_userid: this.userid,
        page_index: this.relation_index,
        page_size: this.relation_size_group,
      });
      EyaoSaasGetRoomListByUserID(req)
        .then((res) => {
          if (res) {
            this.relation_list_group = res.list;
            this.relation_total_group = res.total;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    person_list(index) {
      this.relation_index = 1;
      this.person_list_index = index;
      // this.relation_list_index = index;
      if (index === 3) {
        this.groupChat();
      } else {
        this.EyaoSaasGetChatListByUserID();
      }
    },
    loadNode(node, resolve) {
      // 用于tree的载入函数

      if (node.level === 0) {
        // 只有在第一次加载时需要loading
        this.treeLoading = true;
        this.nodeHead = node;
        this.resolveHead = resolve;
      } else {
        this.departmentId = node.data.id;
      }

      this.getDepartments().then((data) => {
        if (node.level === 0) {
          // 设置顶节点公司名 & 多加载一层
          this.firm_name = data.department_list[0].name;
          this.departmentId = data.department_list[0].id;
          this.getDepartments().then((data) => {
            this.resolveData(resolve, data);
            this.treeLoading = false;
          });
        } else {
          this.resolveData(resolve, data);
        }
      });
    },
    resolveData(resolve, data) {
      if (data.department_list && data.user_list) {
        for (const item of data.user_list) {
          item.leaf = true;
        }
        resolve([...data.department_list, ...data.user_list]);
      } else {
        resolve([]);
      }
    },
    getDepartments() {
      return new Promise((resolve) => {
        GetWeComDepartmentById({
          agent_id: -1,
          department_id: this.departmentId,
          judge_status: 1,
        })
          .then((res) => {
            console.log(res);
            resolve(res);
          })
          .catch((e) => {
            this.$message.error(e);
            resolve();
          });
      });
    },
    deb(fn, time) {
      // 防抖函数
      const clearTimer = function () {
        fn.call();
        this.searchTimer = null;
      };

      return () => {
        if (this.searchTimer) {
          clearTimeout(this.searchTimer);
          this.searchTimer = null;
        }
        this.searchTimer = setTimeout(clearTimer, time);
      };
    },
    searchName() {
      // 搜索人员
      const tempFun = this.deb(() => {
        if (this.filterText.length === 0) {
          // 避免发送为空的搜索请求
          return;
        }
        GetWeComUserByName({
          name: this.filterText,
          agent_id: this.agentId,
        })
          .then((res) => {
            console.log(res);
            this.searchUserList = res.user_detail_list || [];
            this.searchDepartmentList = res.department_detail_list || [];
            this.fewUser = true;
            this.fewDepartment = true;
            this.showSearchResult = true;
          })
          .catch((e) => {
            this.$message.error(e);
          });
      }, 300);
      tempFun();
    },
    openSearchResult() {
      // 点击输入框时显示上一次的搜索结果
      if (this.filterText.length) {
        this.showSearchResult = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
